import { browserLogger } from '@widget/utils/datadog';

export const getUserTimeZone = () => {
  try {
    // current support is 93%, for the rest 7% we will use default
    return Intl.DateTimeFormat().resolvedOptions().timeZone || 'Europe/Berlin';
  } catch (err) {
    browserLogger.error(err, "Can't get user's timezone");
    return 'Europe/Berlin';
  }
};
